import { FormField } from '@cp/ds/src/components/form';
import React from 'react';
import { RangeInputValueItemRenderFn } from '@cp/ds/src/components/form/components/field/range/model';
import { Box } from '@cp/ds/src/components/box';
import { useTheme } from '@cp/ds/src/hooks';
import { FormFieldName } from '../../model/form';

const STEP_SIZE = 100;
const STEPS_COUNT = 15;
const MIN = 0;
const MAX = STEP_SIZE * STEPS_COUNT;

export const PriceField: React.FC = () => {
  const theme = useTheme();

  const renderValueItem = React.useCallback<RangeInputValueItemRenderFn>(
    (newValue, { index }) => (
      <React.Fragment>
        <Box component="span" sx={{ color: 'gray' }}>
          {index ? 'до' : 'от'}
        </Box>{' '}
        {newValue} ₽
      </React.Fragment>
    ),
    [],
  );

  return (
    <FormField
      fieldLabel="Стоимость за час"
      max={MAX}
      min={MIN}
      name={FormFieldName.Price}
      renderValueItem={renderValueItem}
      size="small"
      step={STEP_SIZE}
      sx={{ width: 1, backgroundColor: theme.palette.white }}
      type="range"
    />
  );
};
